export class OrderData {
    column?: number;
    dir?: string | undefined;
    name?: string | undefined;
}
